/**
 * Formats an array of strings into a human-readable comma-separated list with "and".
 *
 * Handles different array lengths appropriately:
 * - Empty array: returns empty string
 * - Single item: returns the item
 * - Multiple items: joins with commas and adds "and" before the last item
 *
 * @param items - Array of strings to format
 * @returns Formatted string with proper comma enumeration
 *
 * @example
 * ```typescript
 * formatCommaEnumeration([]) // returns ''
 * formatCommaEnumeration(['apple']) // returns 'apple'
 * formatCommaEnumeration(['apple', 'banana']) // returns 'apple and banana'
 * formatCommaEnumeration(['apple', 'banana', 'cherry']) // returns 'apple, banana and cherry'
 * ```
 */
export default function formatCommaEnumeration(items: Array<string>): string {
  if (items.length === 0) {
    return ''
  } else if (items.length === 1) {
    return items[0] || ''
  } else {
    const allButLast = items.slice(0, items.length - 1)
    const last = items[items.length - 1] || ''
    return `${allButLast.join(', ')} and ${last}`
  }
}
